// De taal van een open vragenlijst zit in het pad, niet in state:
// /:client/questionnaireopen/:questionnaire/:moment/:research/:persona/open/:language
// Dat is dezelfde vorm die de deellink en de QR-code genereren, dus de wissel
// blijft deelbaar en de sessie legt de gekozen taal vast.
const LANGUAGE_INDEX = 8;

/**
 * Herschrijft het taalsegment van een questionnaireopen-pad.
 *
 * @param {string} pathname - Huidig pad, bijv. '/tenant/questionnaireopen/q/m/r/p/open/nl'
 * @param {string} languageCode - Nieuwe taalcode, bijv. 'tr'
 * @returns {string} Pad met het taalsegment vervangen of toegevoegd
 */
const buildQuestionnaireLanguagePath = (pathname, languageCode) => {
    if (!languageCode) return pathname;

    const parts = (pathname || '').split('/');

    // Een trailing slash levert een leeg laatste segment op; dat zou het
    // taalsegment een plek opschuiven.
    if (parts.length > 1 && parts[parts.length - 1] === '') parts.pop();

    while (parts.length <= LANGUAGE_INDEX) parts.push('');

    parts[LANGUAGE_INDEX] = languageCode;

    return parts.join('/');
};

export default buildQuestionnaireLanguagePath;
